import React from 'react';
import { View } from 'react-native';
import GestureRecognizer from 'react-native-swipe-gestures';
import OutsidePressHandler from 'react-native-outside-press';

import { scale } from '@components/frame';
import { isPhone } from '@helpers';

import { getBoxShadowStyle } from '@styles/shadow';

import Header from './header';
import Popup from './popup';
import BarChart from './barChart';
import LineChart from './lineChart';
import { connect } from 'react-redux';
import { setChartType } from '@reducers/params';
import { CHART_TYPE, SCREEN_BORDER_RADIUS } from '@v2/pages/common/constants/base.constants';

const Chart = (props) => {
  const { C, fullWidth, fullHeight, setSelectedIndex, setSelectedItem, selectedIndex, changeDate, showLine, setChartType } = props;

  const config = {
    velocityThreshold: 0.3,
    directionalOffsetThreshold: 80,
  };

  const triggerLine = () => setChartType(showLine ? CHART_TYPE.BAR : CHART_TYPE.LINE);

  return (
    <View
      style={[
        {
          borderRadius: scale(SCREEN_BORDER_RADIUS),
        },
        isPhone && {
          overflow: 'hidden',
        },
      ]}
    >
      <View
        style={[
          getBoxShadowStyle({ type: 'Field', C }),
          {
            width: fullWidth,
            height: fullHeight,
            backgroundColor: C('Background/Light/Field'),
            borderRadius: scale(SCREEN_BORDER_RADIUS),
          },
        ]}
      >
        <View
          style={{
            paddingHorizontal: scale(15),
          }}
        >
          {selectedIndex !== null ? (
            <Popup {...{ ...props, triggerLine }} />
          ) : (
            <GestureRecognizer onSwipeLeft={triggerLine} onSwipeRight={triggerLine} config={config}>
              <Header
                {...{
                  ...props,
                  triggerLine,
                }}
              />
            </GestureRecognizer>
          )}
          <GestureRecognizer onSwipeLeft={() => changeDate('add')} onSwipeRight={() => changeDate('substruct')} config={config}>
            {showLine ? (
              <LineChart {...props} />
            ) : (
              <OutsidePressHandler
                onOutsidePress={() => {
                  setSelectedIndex(null);
                  setSelectedItem(null);
                }}
              >
                <BarChart {...{ ...props }} />
              </OutsidePressHandler>
            )}
          </GestureRecognizer>
        </View>
      </View>
    </View>
  );
};

export default connect(null, { setChartType })(Chart);
